import Image from 'next/image';

import { LandingPageProps } from '..';

import services1Image from './images/services/1.png';
import services2Image from './images/services/2.png';
import services3Image from './images/services/3.png';

type TagItemProps = {
  keyword: string;
};

const TagItem: React.FC<TagItemProps> = ({ keyword }) => {
  return (
    <div className="whitespace-nowrap rounded bg-gray-200 p-[5px] text-[9px] font-bold">
      {keyword}
    </div>
  );
};

type ServiceItem = {
  title: string;
  image: StaticImageData;
  description: JSX.Element;
  descriptionTags?: string[];
};

type ServiceDescriptionProps = {
  serviceItem: ServiceItem;
};

const ServiceDescription: React.FC<ServiceDescriptionProps> = ({
  serviceItem,
}) => {
  return (
    <div className="flex basis-1/3 flex-col items-center justify-center">
      <Image alt="" src={serviceItem.image} className="block w-full" />
      <div className="my-6 w-4/5 text-center text-lg font-bold md:w-full">
        {serviceItem.title}
      </div>
      <div className="w-full px-1">
        {serviceItem.description}
        {serviceItem.descriptionTags && (
          <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[10px] font-bold">
            {serviceItem.descriptionTags.map(tag => (
              <TagItem key={tag} keyword={tag} />
            ))}
            <div className="whitespace-nowrap text-sm">など</div>
          </div>
        )}
      </div>
    </div>
  );
};

type Props = {
  lpProps: LandingPageProps;
};

const Component: React.FC<Props> = ({ lpProps }) => {
  const orangeTextClass = 'font-bold text-orange-600';
  const serviceItems = [
    {
      title: '会員限定動画コンテンツで技術を身につける',
      image: services1Image,
      description: (
        <>
          自身の戦型、課題からレッスンを選択できます。現時点でレッスン動画は
          {lpProps.totalVideos}本以上！
          <span className={orangeTextClass}>
            技術の説明から習得のコツ、対人戦での活用法
          </span>
          について丁寧に紹介します。
          <div className="h-1" />
          <span className={orangeTextClass}>例えばサーブなら</span>
        </>
      ),
      descriptionTags: ['巻き込みサーブ', 'ロングサーブ', 'サーブの使いわけ'],
    },
    {
      title: '現役プロコーチが作成したコースで体系的に技術を学べる',
      image: services2Image,
      description: (
        <>
          <span className={orangeTextClass}>
            シェークハンズ専属のプロコーチ
          </span>
          がレッスンを通じて発見したお客様の課題を元に
          <span className={orangeTextClass}>レッスン動画</span>のコースを作成！
          <ul className="mb-1 mt-4 list-inside text-[15px]">
            <li>初めてのサーブの打ち方</li>
            <li>試合前にオススメの練習法</li>
            <li>部活で行うべき効率良い練習メニュー</li>
          </ul>
          ほか多数
        </>
      ),
    },
    {
      title: '専用のマイページでレッスンを管理',
      image: services3Image,
      description: (
        <>
          レッスンした項目を登録できるので、
          <span className={orangeTextClass}>どこまで見たか忘れません</span> !
          どこまでやったのか、次の練習で何を試すか？
          マイページでいつでも振り返ることができます。
        </>
      ),
    },
  ];
  return (
    <div className="mb-5 mt-4 flex w-full flex-col items-start gap-y-7 md:mb-10 md:flex-row md:gap-x-5">
      {serviceItems.map(serviceItem => (
        <ServiceDescription key={serviceItem.title} serviceItem={serviceItem} />
      ))}
    </div>
  );
};

export default Component;
